export default function PageHeader({ title, subtitle, children, testId }) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4 mb-8 animate-rise" data-testid={testId}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#111B21]">{title}</h1>
        {subtitle && <p className="mt-2 text-sm sm:text-base text-slate-500 max-w-2xl">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </header>
  );
}
